/**
 * @Author: derhaod
 * @Date: 2026-01-20
 * @Explain: AI Summary Module
 */
export default {
  // Main page
  'AI.SUMMARY.PAGE.TITLE': 'AI Analytics',
  'AI.SUMMARY.DATA.SOURCE': 'Source:',

  // Overview component
  'AI.SUMMARY.OVERVIEW.AI.ANALYTICS': 'AI Analytics',
  'AI.SUMMARY.OVERVIEW.MODEL': 'Model',

  // Sentiment component
  'AI.SUMMARY.SENTIMENT.TITLE': 'Sentiment',
  'AI.SUMMARY.SENTIMENT.DISTRIBUTION': 'Sentiment distribution',
  'AI.SUMMARY.SENTIMENT.TOTAL.ANALYZED': 'Total analyzed messages',
  'AI.SUMMARY.SENTIMENT.PULSE.24H': '72h sentiment pulse',
  'AI.SUMMARY.SENTIMENT.TIMEZONE': 'Timezone',
  'AI.SUMMARY.SENTIMENT.LEGEND': 'Sentiment',
  'AI.SUMMARY.SENTIMENT.SENTIMENT.SCORE': 'Sentiment score',

  // HighValuedMessages component
  'AI.SUMMARY.HIGH.VALUED.TITLE': 'High-valued messages',
  'AI.SUMMARY.HIGH.VALUED.BUG.REPORTS': 'Bug reports',
  'AI.SUMMARY.HIGH.VALUED.SUGGESTIONS': 'Suggestions',
  'AI.SUMMARY.HIGH.VALUED.COMPLIMENTS': 'Compliments',
  'AI.SUMMARY.VIEW.CONTENT': 'View content',
  'AI.SUMMARY.HIGH.VALUED.COLLAPSE': 'Collapse',
  'AI.SUMMARY.ANALYZING': 'AI is analyzing...',
  'AI.SUMMARY.ANALYZING.LABEL': 'AI Analyzing:',
  'AI.SUMMARY.CONTEXTUAL.CONVERSATION': 'Contextual conversation',

  // Sentiment types
  'AI.SUMMARY.SENTIMENT.TYPE.POSITIVE': 'Positive',
  'AI.SUMMARY.SENTIMENT.TYPE.NEGATIVE': 'Negative',
  'AI.SUMMARY.SENTIMENT.TYPE.NEUTRAL': 'Neutral',

  // Thinking texts
  'AI.SUMMARY.THINKING.ANALYZING.DATA': 'Analyzing data...',
  'AI.SUMMARY.THINKING.ORGANIZING.INFO': 'Organizing information...',
  'AI.SUMMARY.THINKING.GENERATING.SUMMARY': 'Generating summary...',
};
